// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { millisecondsToSeconds as fn } from "../millisecondsToSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const millisecondsToSeconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default millisecondsToSeconds;
